<template>
  <div id="app">
    <router-view />
    <Modal_
      :visible="activateVisible.visible1"
      title="权限激活"
      okText="激 活"
      cancelText="申请试用"
      :isJump="true"
      @Ok="handleSubmit('formData1')"
      @Cancel="
        SET_ACTIVATEVISIBLE({ filed: 'visible1', status: false })
        SET_ACTIVATEVISIBLE({ filed: 'visible4', status: true })
      "
      @jumpOver="handleJumpOver"
    >
      <Form ref="formData1" :model="formData" :rules="rules" class="formdata">
        <FormItem prop="activationCode">
          <p class="label">请输入激活码获取使用权限</p>
          <Input v-model="formData.activationCode" placeholder="请输入"></Input>
        </FormItem>
      </Form>
    </Modal_>
    <Modal_ :visible="activateVisible.visible2" :noCancel="true" title="权限激活" @Ok="SET_ACTIVATEVISIBLE({ filed: 'visible2', status: false })">
      <div class="margin-auto act-success">
        <h3>恭喜！您已经获得如下环境的权限！</h3>
        <br />
        <ul>
          <li v-for="(item, index) in haveAuthList" :key="index">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </Modal_>
    <Modal_
      :visible="activateVisible.visible3"
      title="权限激活"
      okText="重新输入"
      cancelText="退出"
      @Ok="
        SET_ACTIVATEVISIBLE({ filed: 'visible1', status: true })
        SET_ACTIVATEVISIBLE({ filed: 'visible3', status: false })
      "
      @Cancel="SET_ACTIVATEVISIBLE({ filed: 'visible3', status: false })"
    >
      <div class="margin-auto act-err">
        <h3>激活失败</h3>
        <br />
        <br />
        <p>{{ errText }}</p>
      </div>
    </Modal_>
    <Modal_ :visible="activateVisible.visible4" @Cancel="SET_ACTIVATEVISIBLE({ filed: 'visible4', status: false })" @Ok="handleSubmit2('formData2')">
      <div class="margin-auto apply">
        <p>您可通过以下方式联系到我们：</p>
        <Img src="/home/qrcode.jpg" class="code" />
        <p class="info">微信号：svs007admin</p>
        <p class="info">邮箱：contact@svinsight.com</p>
        <br />
        <br />
        <Form ref="formData2" :model="formData" :rules="rules" class="formdata">
          <FormItem prop="phone">
            <p class="label">或留下方便的联系方式，我们将尽快与您联系：</p>
            <Input v-model="formData.phone" placeholder="请输入"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal_>
  </div>
</template>
<script>
import Modal_ from '@/components/Modal'
import { Form, FormItem, Input } from 'view-design'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    Modal_,
    Form,
    FormItem,
    Input
  },
  data() {
    return {
      haveAuthList: [], // 拥有的权限
      formData: {
        activationCode: '', // 激活码
        phone: '' // 手机号
      },
      rules: {
        activationCode: [{ required: true, message: '请输入激活码', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },
      errText: ''
    }
  },
  computed: {
    ...mapState(['userinfo', 'activateVisible', 'userLimits'])
  },
  methods: {
    ...mapMutations(['SET_ACTIVATEVISIBLE']),
    // 验证
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleActivate()
        }
      })
    },
    // 激活
    async handleActivate() {
      const params = {
        uriCode: 'API013',
        code: this.formData.activationCode,
        kind: this.userinfo.kind
      }

      try {
        const res = await this.$fetch(params)
        this.haveAuthList = res
        this.SET_ACTIVATEVISIBLE({ filed: 'visible1', status: false })
        this.$refs['formData1'].resetFields()
        this.SET_ACTIVATEVISIBLE({ filed: 'visible2', status: true })
        this.formData.activationCode = ''
        this.formData.phone = ''
        this.$store.dispatch('getUserinfo')
      } catch (e) {
        this.errText = e.data.msg
        this.SET_ACTIVATEVISIBLE({ filed: 'visible1', status: false })
        this.$refs['formData1'].resetFields()
        this.SET_ACTIVATEVISIBLE({ filed: 'visible3', status: true })
      }
    },
    // 验证
    handleSubmit2(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.saveCustomer()
        }
      })
    },
    // 激活
    async saveCustomer() {
      const params = {
        uriCode: 'API014',
        phone: this.formData.phone
      }
      await this.$fetch(params)
      this.SET_ACTIVATEVISIBLE({ filed: 'visible4', status: false })
      this.$refs['formData1'].resetFields()
      this.formData.phone = ''
    },
    // 跳过激活
    handleJumpOver() {
      this.SET_ACTIVATEVISIBLE({ filed: 'visible1', status: false })
      this.$refs['formData1'].resetFields()
      localStorage.setItem('jumpActivate', '1')
      this.formData.activationCode = ''
      this.formData.phone = ''
    }
  },

  watch: {
    // 监听是否需要自动弹出激活弹窗（如果未激活并且没有跳过就弹出）
    userLimits(val) {
      const jumpActivate = localStorage.getItem('jumpActivate')
      if (val?.state === 1 && !jumpActivate && this.$route.name !== 'invite') {
        this.formData.activationCode = ''
        this.formData.phone = ''
        this.SET_ACTIVATEVISIBLE({ filed: 'visible1', status: true })
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/reset.scss';
@import '@/assets/css/index.scss';

.formdata {
  width: 400px;
  margin: 100px auto;

  .label {
    margin-bottom: 15px;
  }
}

.act-success {
  width: 300px;

  li {
    line-height: 30px;
  }
}

.act-err {
  width: 380px;
  margin-top: 100px;
}

.apply {
  width: 400px;

  .code {
    width: 120px;
    height: 120px;
    margin: 20px 0;
  }

  .info {
    color: #666666;
  }

  .formdata {
    margin: 0;
  }
}
</style>
